export const  SIDEBAR_MENU_ITEM_CLICK = "Sidebar_Menu_Item_Click";